import { createIcon } from '@chakra-ui/react';

export const InvalidSubscriptionIllustration = createIcon({
  displayName: 'InvalidSubscriptionIllustration',
  viewBox: '0 0 240 240',
  defaultProps: {
    fill: 'none',
    width: '240px',
    height: '240px',
  },
  path: (
    <>
      <mask
        id="mask0_361_119"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="240"
        height="240"
      >
        <circle cx="120" cy="120" r="120" fill="#F1F8FE" />
      </mask>
      <g mask="url(#mask0_361_119)">
        <g filter="url(#filter0_dd_361_119)">
          <g filter="url(#filter1_dd_361_119)">
            <path
              d="M75.5001 49C68.5001 36.5 81.121 32.0495 76.4999 23C72.3794 14.931 58.0001 9 58.0001 9"
              stroke="#BCCCDC"
              strokeWidth="6"
            />
          </g>
          <path
            d="M129.89 76.7654L74.4641 108.765L60.4326 84.4621C52.374 70.5041 61.2634 54.0329 75.1769 46C89.0904 37.967 107.8 38.5041 115.858 52.4621L129.89 76.7654Z"
            fill="#BCCCDC"
          />
          <rect
            x="66.5"
            y="102.971"
            width="72"
            height="17"
            rx="4"
            transform="rotate(-30 66.5 102.971)"
            fill="#0F5291"
          />
        </g>
        <path
          d="M65.6291 144.25L51.7727 152.25"
          stroke="#F86A6A"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M60.2272 128.894L48.2272 128.894"
          stroke="#F86A6A"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M76.2272 156.606L70.2272 166.999"
          stroke="#F86A6A"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M168.598 88.0526L182.455 80.0526"
          stroke="#F86A6A"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path d="M158 75.6961L164 65.3038" stroke="#F86A6A" strokeWidth="6" strokeLinecap="round" />
        <path d="M174 103.409L186 103.409" stroke="#F86A6A" strokeWidth="6" strokeLinecap="round" />
        <g filter="url(#filter2_dd_361_119)">
          <path
            d="M106.464 158.928L161.89 126.928L175.921 151.231C183.98 165.19 175.09 181.661 161.177 189.694C147.263 197.727 128.554 197.189 120.496 183.231L106.464 158.928Z"
            fill="#BCCCDC"
          />
          <rect
            x="169.854"
            y="132.722"
            width="72"
            height="17"
            rx="4"
            transform="rotate(150 169.854 132.722)"
            fill="#0F5291"
          />
          <path
            d="M104.856 132.144C103.752 130.23 104.407 127.784 106.32 126.68C108.234 125.575 110.68 126.23 111.785 128.144L119.785 142L112.856 146L104.856 132.144Z"
            fill="white"
          />
          <path
            d="M132.569 116.144C131.465 114.23 132.12 111.784 134.033 110.68C135.946 109.575 138.393 110.23 139.497 112.144L147.497 126L140.569 130L132.569 116.144Z"
            fill="white"
          />
          <g filter="url(#filter3_dd_361_119)">
            <path
              d="M161 188.5C168.5 199 176.414 191.878 181 199C188.428 210.535 150.5 220 166.5 231"
              stroke="#BCCCDC"
              strokeWidth="6"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_361_119"
          x="32"
          y="4.22714"
          width="117.354"
          height="135.466"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_361_119"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_119" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_361_119"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_361_119"
            result="effect2_dropShadow_361_119"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_361_119"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_361_119"
          x="44.8546"
          y="4.22714"
          width="47.6846"
          height="68.2387"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_361_119"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_119" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_361_119"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_361_119"
            result="effect2_dropShadow_361_119"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_361_119"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_361_119"
          x="86.9999"
          y="108.143"
          width="117.354"
          height="147.329"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_361_119"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_119" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_361_119"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_361_119"
            result="effect2_dropShadow_361_119"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_361_119"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_dd_361_119"
          x="146.559"
          y="184.756"
          width="50.4171"
          height="70.7159"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_361_119"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_119" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_361_119"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_361_119"
            result="effect2_dropShadow_361_119"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_361_119"
            result="shape"
          />
        </filter>
      </defs>
    </>
  ),
});
